import '../styles/button.css'

// Expected variants: primary, secondary, tertiary, accent

const Button = ({ 
    variant = 'primary',
    icon,
    text,
    disabled,
    type = 'button',
    handleClick
 }) => {
    
  return (
    <button 
        className={`btn-${variant}`}
        disabled={disabled}
        type={type}
        onClick={handleClick}
    >
        {icon && <span className='btn-icon'>{icon}</span>}
        {text}
    </button>
  )
}

export default Button